import { Circle } from "@react-three/drei"

import { buildings, colors } from "../../helpers/constants"

const { ground, shadow } = colors

const Material = () => (
  <meshPhongMaterial
    emissive={ground}
    emissiveIntensity={0.2}
    flatShading
    color={ground}
  />
)

export const BG = ({ nodes }) => (
  <>
    <group position={buildings.bg.position}>
      {buildings.bg.geometries.map((geometry, i) => (
        <mesh key={i} geometry={nodes[geometry].geometry} castShadow>
          <Material />
        </mesh>
      ))}
    </group>
    <Circle
      args={[700, 30]}
      receiveShadow
      rotation={[-Math.PI / 2, 0, 0]}
      position-y={-0.7}
    >
      <shadowMaterial transparent color={shadow} />
    </Circle>
    <Circle args={[700, 30]} position-y={-0.75} rotation={[-Math.PI / 2, 0, 0]}>
      <meshBasicMaterial color={ground} />
    </Circle>
  </>
)
